export default __webpack_public_path__ + "static/media/100_18621.db12da74.jpg";